import { GET_PROJECTS, PROJECT_ERROR, GET_PROJECTS_BY_CATEGORY } from '../types'

export default (state, action) => {
    switch(action.type){
        case GET_PROJECTS:
            return {
                ...state,
                projects: action.payload.projects,
                categories: action.payload.categories,
                loading: false,
                count: action.payload.projects.length
            }

        case GET_PROJECTS_BY_CATEGORY:
            return {
                ...state,
                projects: action.payload,
                loading: false,
                count: action.payload.length
            }
        
        case PROJECT_ERROR:
            return {
                ...state,
                projects: null,
                count: 0,
                loading: false
            }
        default: return state
    }
}